var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.componentClass,style:(_vm.componentStyle),attrs:{"data-testid":"skeletonLoader"}},[(!_vm.isLoading)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }